module.exports = __webpack_public_path__ + "static/media/furniture.291f3b65.svg";